<div class="flex flex-col gap-3" [attr.data-testid]="testId()">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <p
      class="flex items-center gap-2 text-sm text-muted-color"
      [attr.data-testid]="testId() + '-hint'"
    >
      <i class="pi pi-info-circle"></i>
      {{ 'project.steps.criteriaWeightsOverview.treeHint' | transloco }}
    </p>

    <app-criteria-weights-tree-controls
      [testId]="testId() + '-controls'"
      [zoomLabel]="zoomLabel()"
      (zoomIn)="zoomIn()"
      (zoomOut)="zoomOut()"
      (resetView)="resetView()"
    />
  </div>

  <div
    #viewport
    class="relative h-[clamp(20rem,58vh,44rem)] overflow-clip rounded-lg bg-first-level touch-none select-none"
    [class]="viewportCursorClass()"
    [attr.data-testid]="testId() + '-viewport'"
    (wheel)="zoomWithWheel($event)"
    (pointerdown)="startPanning($event)"
    (pointermove)="pan($event)"
    (pointerup)="stopPanning($event)"
    (pointercancel)="stopPanning($event)"
  >
    <div
      class="absolute top-0 left-0 origin-top-left"
      [style.transform]="canvasTransform()"
      [style.width.px]="layout().width"
      [style.height.px]="layout().height"
      [attr.data-testid]="testId() + '-canvas'"
    >
      <svg
        class="absolute top-0 left-0 overflow-visible"
        aria-hidden="true"
        [attr.width]="layout().width"
        [attr.height]="layout().height"
      >
        @for (link of layout().links; track link.key) {
          <path class="criteria-weights-tree-link" [attr.d]="link.path" />
        }
      </svg>

      <div
        class="criteria-weights-tree-root absolute flex items-center gap-2 px-3 rounded-lg bg-third-level border"
        [style.left.px]="layout().root.x"
        [style.top.px]="layout().root.y"
        [style.width.px]="layout().root.width"
        [style.height.px]="TREE_NODE_HEIGHT"
        [attr.data-testid]="testId() + '-root'"
      >
        <span class="flex-1 min-w-0 truncate font-bold">
          {{ 'project.steps.criteriaWeightsOverview.treeRoot' | transloco }}
        </span>
        <span class="shrink-0 font-medium tabular-nums text-button-red">
          {{ layout().root.weight | criteriaWeight }}
        </span>
      </div>

      @for (node of criterionNodes(); track node.criterion.id) {
        <button
          type="button"
          data-tree-criterion
          class="absolute flex items-center gap-2 pl-2 pr-3 rounded-lg bg-third-level border border-transparent text-left cursor-pointer"
          [class.criteria-weights-tree-node-expanded]="node.expanded"
          [style.left.px]="node.x"
          [style.top.px]="node.y"
          [style.width.px]="node.width"
          [style.height.px]="TREE_NODE_HEIGHT"
          [attr.aria-expanded]="node.ariaExpanded"
          [attr.title]="node.criterion.translations | translateDirectus"
          [attr.data-testid]="testId() + '-criterion-' + node.criterion.id"
          (click)="toggleCriterion(node.criterion.id)"
        >
          <span
            class="w-1 h-7 rounded-full shrink-0"
            [style.background-color]="node.criterion.color"
          ></span>
          <span class="text-sm shrink-0">{{ node.criterion.identifier }}</span>
          <span
            class="flex-1 min-w-0 truncate"
            [attr.data-testid]="testId() + '-criterion-name-' + node.criterion.id"
          >
            {{ node.criterion.translations | translateDirectus }}
          </span>
          <span
            class="w-16 shrink-0 text-right font-medium tabular-nums text-button-red"
            [attr.data-testid]="testId() + '-criterion-weight-' + node.criterion.id"
          >
            {{ node.criterion.weight | criteriaWeight }}
          </span>
          <i
            class="w-4 shrink-0 text-xs text-center"
            [class]="node.toggleIcon"
            [attr.data-testid]="testId() + '-criterion-toggle-' + node.criterion.id"
          ></i>
        </button>
      }

      @for (node of layout().subCriteria; track node.subCriterion.id) {
        <div
          class="absolute flex items-center gap-2 px-3 rounded-lg bg-second-level"
          [style.left.px]="node.x"
          [style.top.px]="node.y"
          [style.width.px]="node.width"
          [style.height.px]="TREE_NODE_HEIGHT"
          [attr.title]="node.subCriterion.translations | translateDirectus"
          [attr.data-testid]="testId() + '-sub-criterion-' + node.subCriterion.id"
        >
          <span class="text-sm shrink-0">{{ node.subCriterion.identifier }}</span>
          <span
            class="flex-1 min-w-0 truncate"
            [attr.data-testid]="testId() + '-sub-criterion-name-' + node.subCriterion.id"
          >
            {{ node.subCriterion.translations | translateDirectus }}
          </span>
          <span
            class="w-16 shrink-0 text-right tabular-nums text-button-red"
            [attr.data-testid]="testId() + '-sub-criterion-weight-' + node.subCriterion.id"
          >
            {{ node.subCriterion.weight | criteriaWeight }}
          </span>
        </div>
      }
    </div>
  </div>
</div>
